package com.iptvplayer.shared.data.remote.api

import com.iptvplayer.shared.data.remote.dto.*
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import com.iptvplayer.shared.util.Constants

class WatchHistoryApi(private val client: HttpClient) {
    suspend fun getHistory(limit: Int = 50, offset: Int = 0): List<WatchHistoryDto> =
        client.get("${Constants.BASE_URL}/api/history") {
            parameter("limit", limit)
            parameter("offset", offset)
        }.body()

    suspend fun updateProgress(request: UpdateHistoryRequestDto): WatchHistoryDto =
        client.post("${Constants.BASE_URL}/api/history") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun removeHistory(contentId: String): SuccessResponseDto =
        client.delete("${Constants.BASE_URL}/api/history/$contentId").body()
}
